import Model from "./model";
import Point from "./point";
import Rectangle from "./rectangle";

export default class Vertex {
    currentX(): number {
        return this.current.getX();
    }
    currentY(): number {
        return this.current.getY();
    }

    setCurrentX(x: number ) {
        this.current.setX(x);
    }

    setCurrentY(y: number ) {
        this.current.setY(y);
    }

    getX(): number {
        return this.point.getX();
    }
    getY(): number {
        return this.point.getY();
    }
    getBounds(): Rectangle {
        return new Rectangle(this.point.getX(), this.point.getY(), 5 ,5);
    }
    setId(id: string): any {
        this.id = id;
    }

    public update() {
        return this.shouldupdate;
    }

    public updated() {
        this.shouldupdate = false;
    }


    shouldupdate: boolean;
    model: Model;
    point: Point;
    current: Point;
    id: string;

    constructor(model: Model, x: number, y: number) {
        this.model = model;
        this.point = new Point(x, y);
        this.current = new Point(this.point.getX(), this.point.getY());
        this.id = "null";
        this.shouldupdate = true;
    }
    
    getEdges(): { [id:string]: Vertex } {
        return this.model.getEdges(this.model, this);
    }

    setY(y: number): any {
        this.point.setY(y);
        this.shouldupdate = true;
    }
    setX(x: number): any {
        this.point.setX(x);
    }
    getId(): string {
        return this.id;
    }

}